import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';
import { LinesListComponent } from './components/lines-list/lines-list.component';
import { TokenLocalStorageService } from '../authentication/services/token-local-storage.service';
import { LandLinesListComponent } from '../landlines/components/land-lines-list/land-lines-list.component';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
      {
        path: 'lignes', canActivate: [TokenLocalStorageService], children : [
            { path: '', component: LinesListComponent },
            { path: ':tab/:procedure', pathMatch: 'full', component: LinesListComponent },
            { path: ':tab', component: LinesListComponent },
        ]
      },
      {
        path: 'fixes', canActivate: [TokenLocalStorageService], children: [
          { path: '', component: LandLinesListComponent },
          { path: ':tab/:procedure', pathMatch: 'full', component: LandLinesListComponent },
          { path: ':tab', component: LandLinesListComponent },
        ]
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LinesRoutingModule { }
